import { render, staticRenderFns } from "./delete-confirmation.vue?vue&type=template&id=c1b9e8a0&scoped=true"
import script from "./delete-confirmation.vue?vue&type=script&lang=ts"
export * from "./delete-confirmation.vue?vue&type=script&lang=ts"
import style0 from "./delete-confirmation.vue?vue&type=style&index=0&id=c1b9e8a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b9e8a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1b9e8a0')) {
      api.createRecord('c1b9e8a0', component.options)
    } else {
      api.reload('c1b9e8a0', component.options)
    }
    module.hot.accept("./delete-confirmation.vue?vue&type=template&id=c1b9e8a0&scoped=true", function () {
      api.rerender('c1b9e8a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-portfolio/linked-budget-request-view/linked-budget-request-view-content/delete-confirmation/delete-confirmation.vue"
export default component.exports